import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { CalendarState } from './types';
import { RootState } from '@/vuex/types';
import { range } from 'lodash';
import { esensDefaultFilters, zoukDefaultFilters } from './dafaults';

export const state: CalendarState = {
    weekdaysContainerWidth: 1783,
    weekdayContainerWidth: 254,
    locationWidth: 84,
    boxWidth: 42,
    cellHeight: 42,
    boxType: 'small',
    isMobile: false,
    events: [],
    filteredEvents: [],
    calendarFilters: zoukDefaultFilters(),
    hiddenFilters: '',
    allHours: range(8, 23, 0.5),
    openedSingleActivityPopups: [],
    hoursWithEvents: range(8, 23, 0.5),
};

const namespaced = true;

export const calendar: Module<CalendarState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
